import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import actions from 'redux/actions'
import { constants } from 'common/helpers'

import { Button } from 'components/_new/controls'

import messages from './messages'
import s from './SkipButton.scss'


const SkipButton = ({ className, modalName }) => (
  <Button
    className={cx(s.skipButton, className)}
    title={messages.title}
    color="white"
    size="md"
    onClick={() => {
      actions.models.modals.close(modalName)
      actions.models.modals.open(constants.modals.review.Recommendations)
    }}
  />
)

SkipButton.propTypes = {
  modalName: PropTypes.string,
}


export default SkipButton
